import debug from 'debug';
import Debounce from 'Global/Shared/Components/Debounce/Debounce';
import Breakpoints from 'Minetilbud/Shared/Components/Breakpoints/Breakpoints';

const log = debug('SupportBanner');
const debounce = new Debounce().debounce;

class SupportBanner {
	constructor(element) { 
		this.element = element;

		this.resizeEvent = this.resizeHandler.bind(this);
		this.resizeHandler = debounce(this.resizeHandler, 250);

		this.initialize();
	}

	eventListeners() {
		window.addEventListener('resize', this.resizeEvent, false);
	}

	/**
	 * @returns {Object} settings [catalogId, customerId]
	 */
	 getSettings() {
		let settings = {};

		try {
			settings = JSON.parse(this.element.getAttribute('data-settings'));
			log('getSettings()', settings);
			this.settings = settings;
		} catch (error) {
			log('getSettings() - error', error);
			settings = null;
		}

		return settings;
	}


	initialize() {
		this.getSettings();
		this.setup();
		this.eventListeners();
	}

	resizeHandler() {
		this.setup();
	}

	setup() {
		const breakpoints = new Breakpoints();
		const imageUrl = breakpoints.MediaBreakpointUp('md') ? this.settings.desktopImage : this.settings.deviceImage;

		this.element.setAttribute('style', `background-image: url(${imageUrl})`);
	}
}

export default SupportBanner;
